import { ColumnDef } from "@tanstack/react-table";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import SearchHeader from "../../components/search/searchHeader.tsx";
import InfiniteTable from "../../components/table/infiniteTable.tsx";
import { useInfiniteQueryForApiData } from "../../hooks/queries/useInfiniteQueryForApiData.ts";
import useQueryParams from "../../hooks/useQueryParams.ts";

type Props<T> = {
  route: string;
  resultsColumnDef: ColumnDef<T>[];
  showSearchBar?: boolean;
  allowEntityCreate?: boolean;
  createButtonLabel?: string;
};
export default function SearchPage<T>({
  route,
  resultsColumnDef,
  showSearchBar = true,
  allowEntityCreate = false,
  createButtonLabel = "New",
}: Props<T>) {
  const navigate = useNavigate();
  const queryParams = useQueryParams();
  const searchedName = queryParams.get("search");
  const searchInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="h-full flex flex-col">
      {showSearchBar && (
        <SearchHeader
          searchInputRef={searchInputRef}
          onSearch={(searchValue) =>
            navigate(`/${route}?search=${searchValue}`)
          }
          actions={
            allowEntityCreate
              ? [
                  {
                    label: createButtonLabel,
                    onClick: () => navigate(`/${route}/new`),
                  },
                ]
              : []
          }
        />
      )}
      <div className="p-6 flex-grow min-h-0">
        {searchedName != null && searchedName !== "" && (
          <p className="mb-2 text-sm font-medium text-gray-500">
            Searched for{" "}
            <a href="#" className="text-gray-900">
              {searchedName}
            </a>
            .
            <a
              className="ml-2 text-sm font-medium text-sky-500 hover:text-sky-700 cursor-pointer"
              onClick={() => {
                navigate(`/${route}`);
                searchInputRef.current?.focus();
              }}
            >
              Clear?
            </a>
          </p>
        )}
        <InfiniteTable
          infiniteQuery={() =>
            useInfiniteQueryForApiData<T>({
              apiRoute: route,
              searchValue: searchedName,
            })
          }
          columnDef={resultsColumnDef}
        />
      </div>
    </div>
  );
}
